// Mock data for SOC Analyst Portfolio - Avadhut Lohar

export const profile = {
  name: "Avadhut Lohar",
  role: "SOC Analyst | Incident Responder | Threat Hunter",
  tagline:
    "SOC Analyst with 4+ years of experience in Security Operations Center environments, specializing in SIEM monitoring, incident response, threat analysis, phishing investigations, and endpoint security across 24x7 enterprise infrastructures.",
  location: "India",
  phone: "+91 91467 66298",
  email: "loharavdhoot@gmail.com",
  github: "https://github.com/avadhutlohar",
  linkedin: "https://www.linkedin.com/in/avadhut-lohar/",
  status: "OPEN TO L2 / SENIOR SOC ANALYST ROLES",
  classification: "SOC-ANALYST // L2 // SIEM-EDR-THREAT-HUNT",
};

export const liveAlerts = [
  { sev: "HIGH", text: "Phishing Campaign Detected", src: "Proofpoint", status: "CONTAINED" },
  { sev: "MED", text: "DLP Policy Violation", src: "Proofpoint CASB", status: "INVESTIGATING" },
  { sev: "HIGH", text: "Endpoint Malware Detected", src: "SentinelOne", status: "ISOLATED" },
  { sev: "LOW", text: "Anomalous Cloud API Call", src: "Wiz", status: "MONITORED" },
  { sev: "MED", text: "IOC Match on DNS Logs", src: "Splunk", status: "ENRICHED" },
  { sev: "HIGH", text: "Suspicious PowerShell Execution", src: "Defender XDR", status: "TRIAGED" },
];

export const mitreTechniques = [
  { id: "T1566", name: "Phishing" },
  { id: "T1059", name: "Command Execution" },
  { id: "T1110", name: "Brute Force" },
  { id: "T1078", name: "Valid Accounts" },
  { id: "T1071", name: "App Layer Proto" },
  { id: "T1041", name: "Exfil over C2" },
  { id: "T1486", name: "Data Encryption" },
  { id: "T1190", name: "Exploit Public App" },
];

export const stats = [
  { value: "4+", label: "YEARS IN SOC OPERATIONS" },
  { value: "24x7", label: "ENTERPRISE SOC EXPERIENCE" },
  { value: "SEC+", label: "COMPTIA SECURITY+ CERTIFIED" },
  { value: "SPLUNK", label: "CORE CERTIFIED USER" },
  { value: "MITRE", label: "ATT&CK FRAMEWORK PROFICIENCY" },
];

export const skills = [
  {
    domain: "SIEM & MONITORING",
    icon: "Activity",
    items: ["Splunk", "IBM QRadar", "Log Correlation", "Alert Triage", "Custom Dashboards", "SPL Queries"],
  },
  {
    domain: "ENDPOINT SECURITY",
    icon: "Cpu",
    items: ["SentinelOne", "Carbon Black Cloud", "Cisco AMP", "Microsoft Defender", "Red Canary", "EDR / XDR"],
  },
  {
    domain: "EMAIL SECURITY",
    icon: "Mail",
    items: ["Proofpoint", "Proofpoint CASB", "KnowBe4 PhishER", "Cofense", "Abuse Mailbox", "Header Analysis"],
  },
  {
    domain: "CLOUD & NETWORK",
    icon: "Cloud",
    items: ["Wiz", "Zscaler", "Google Admin", "Axonius", "Wireshark", "Forcepoint", "Burp Suite"],
  },
  {
    domain: "THREAT INTEL & HUNTING",
    icon: "Crosshair",
    items: ["ThreatQ", "IOC Enrichment", "Threat Hunting", "DNS / Web / FW Logs", "Malware Investigation", "VirusTotal"],
  },
  {
    domain: "OPS, FRAMEWORKS & SCRIPTING",
    icon: "Terminal",
    items: ["ServiceNow", "Jira", "Python", "JavaScript", "MITRE ATT&CK", "NIST CSF"],
  },
];

export const experience = [
  {
    code: "EXP-002",
    company: "Global Payments",
    role: "Associate Information Security Analyst",
    period: "Dec 2024 \u2014 Present",
    type: "IN-HOUSE SOC // GSOC",
    bullets: [
      "Operate within both In-House SOC and Global SOC (GSOC) functions, performing real-time monitoring, incident investigation, and response across multi-client infrastructures.",
      "Triage security alerts generated from SIEM, EDR, XDR, email security, and cloud security platforms.",
      "Use Splunk extensively for log analysis, alert monitoring, correlation, and incident investigation.",
      "Leverage Proofpoint for email protection, phishing detection, and email containment; Proofpoint CASB for DLP investigations.",
      "Investigate critical cloud-related alerts and misconfigurations on Wiz Cloud.",
      "Enrich incidents using ThreatQ \u2014 IOC analysis and blocking of malicious indicators identified during active incidents.",
      "Utilize Red Canary, Axonius, Google Admin, Zscaler, Carbon Black, and SentinelOne for endpoint monitoring, cloud security, and threat detection.",
      "Conduct threat hunting on IOCs, endpoint telemetry, DNS, web, firewall, and cloud logs to surface suspicious activity.",
      "Escalate incidents to user managers for confirmation and run bridge calls during critical security incidents and major escalations.",
    ],
    stack: ["Splunk", "Proofpoint", "Wiz", "ThreatQ", "SentinelOne", "Carbon Black", "Red Canary", "Zscaler", "Axonius"],
  },
  {
    code: "EXP-001",
    company: "Infosys LTD",
    role: "Security Analyst",
    period: "Oct 2021 \u2014 Sep 2024",
    type: "ENTERPRISE SOC // L1\u2013L2",
    bullets: [
      "Monitored and analyzed security events through Cisco AMP and Microsoft Defender to identify malicious activity and endpoint threats.",
      "Investigated phishing emails, spam campaigns, malicious URLs, and targeted phishing attacks using KnowBe4 PhishER and Abuse Mailbox workflows.",
      "Performed alert triage, incident escalation, and threat analysis aligned to SOC operational procedures and SLA timelines.",
      "Analyzed logs across multiple security platforms to identify anomalous activity and support rapid incident response.",
      "Generated daily, weekly, and monthly SOC reports covering security incidents, failed logons, internet security events, and threat trends.",
    ],
    stack: ["Cisco AMP", "Microsoft Defender", "KnowBe4 PhishER", "Abuse Mailbox", "SOC Reporting", "SLA Mgmt"],
  },
];

export const projects = [
  {
    code: "PRJ-001",
    type: "THREAT INTEL TOOL",
    title: "IOC Analyzer \u2014 Automated Indicator Analysis Platform",
    desc: "A Python-based IOC Analyzer platform for automated analysis of malicious IPs, domains, URLs, and file hashes. Integrates threat intelligence enrichment workflows for faster SOC investigations, with a modern web interface deployed on Vercel. Designed to accelerate triage, reduce manual lookup time, and standardize IOC verdicts across investigations.",
    tags: ["Python", "Threat Intelligence", "IOC Enrichment", "Web App", "Vercel", "SOC Tooling"],
    link: "https://iocanalyzer.vercel.app/",
    repo: "https://github.com/avadhutlohar/IOC_Analyzer",
  },
];

export const dashboardAlerts = [
  { ts: "2025-11-04 02:14", name: "Targeted Phishing \u2014 Executive Inbox", sev: "HIGH", status: "CONTAINED", source: "Proofpoint" },
  { ts: "2025-11-04 02:31", name: "Suspicious PowerShell Execution", sev: "HIGH", status: "TRIAGED", source: "SentinelOne" },
  { ts: "2025-11-04 03:05", name: "DLP Violation \u2014 Sensitive Data Upload", sev: "MED", status: "INVESTIGATING", source: "Proofpoint CASB" },
  { ts: "2025-11-04 03:22", name: "Anomalous AWS API Activity", sev: "MED", status: "ENRICHED", source: "Wiz" },
  { ts: "2025-11-04 04:10", name: "IOC Match \u2014 Known C2 Domain", sev: "HIGH", status: "BLOCKED", source: "ThreatQ" },
  { ts: "2025-11-04 04:42", name: "Failed Logon Spike", sev: "LOW", status: "MONITORED", source: "Splunk" },
];

export const playbooks = [
  {
    icon: "Mail",
    title: "PHISHING INVESTIGATION",
    steps: [
      "Pull email from Proofpoint / PhishER and review full headers (SPF / DKIM / DMARC)",
      "Detonate URLs and attachments in sandbox; capture domain & file hash IOCs",
      "Enrich IOCs in ThreatQ / VirusTotal and check sender domain reputation",
      "Identify recipients and pivot to mail-gateway logs to scope blast radius",
      "Contain mail, block sender / URLs, notify users, document & close per SLA",
    ],
  },
  {
    icon: "Bug",
    title: "ENDPOINT MALWARE TRIAGE",
    steps: [
      "Open alert in SentinelOne / Defender / Carbon Black and review process tree",
      "Validate file hash against threat intel; confirm true-positive vs. false-positive",
      "Pivot to Splunk for parent process, command line, network and DNS telemetry",
      "Isolate endpoint, kill process, quarantine binary, and collect forensic artifacts",
      "Document IOCs in ThreatQ, push blocks, escalate to L3 if persistence detected",
    ],
  },
  {
    icon: "Cloud",
    title: "CLOUD ALERT INVESTIGATION",
    steps: [
      "Review Wiz alert context \u2014 resource, identity, severity, and attack path",
      "Correlate with CloudTrail / API logs in Splunk for the actor and source IP",
      "Validate against known change windows, IAM posture, and approved automation",
      "Revoke risky tokens, rotate credentials, and harden misconfigurations",
      "Open ServiceNow ticket, notify cloud owners, track remediation to closure",
    ],
  },
  {
    icon: "KeyRound",
    title: "PHISHING-LED ACCOUNT COMPROMISE",
    steps: [
      "Confirm credential entry on phishing page from email & user attestation",
      "Pull sign-in logs from Defender / Google Admin \u2014 check geo, ISP, MFA prompts",
      "Force password reset, revoke sessions and OAuth tokens, re-enroll MFA",
      "Hunt for mailbox rules, OAuth grants, and lateral movement in Splunk",
      "Notify manager, file incident report, run bridge call if scope expands",
    ],
  },
];

export const certifications = [
  { icon: "Award", name: "CompTIA Security+", issuer: "COMPTIA", status: "CERTIFIED", state: "done" },
  { icon: "Activity", name: "Splunk Core Certified User", issuer: "SPLUNK", status: "CERTIFIED", state: "done" },
  { icon: "Microscope", name: "SOC Level 1 Analyst", issuer: "TRYHACKME", status: "COMPLETED", state: "done" },
  { icon: "ShieldCheck", name: "MITRE ATT&CK Defender Concepts", issuer: "HANDS-ON PRACTICE", state: "done", status: "APPLIED IN OPS" },
];

// Education kept minimal / removed in favor of Experience-led layout
export const education = [];

export const nav = [
  { id: "about", label: "ABOUT" },
  { id: "skills", label: "SKILLS" },
  { id: "experience", label: "EXPERIENCE" },
  { id: "projects", label: "PROJECTS" },
  { id: "dashboard", label: "DASHBOARD" },
  { id: "playbooks", label: "PLAYBOOKS" },
  { id: "certs", label: "CERTS" },
  { id: "contact", label: "CONTACT" },
];
